import type { Asset } from '@schibsted-svp/svp-api-types';
import relatedService from 'player/services/api/related';
import { AssetModel } from 'player/model/asset';

const mapResponse = (vendor: string, assets: Asset[]): AssetModel[] =>
    assets.map(
        (asset) =>
            new AssetModel({
                vendor,
                ...asset,
            }),
    );

const recommendedList = {
    fetchFromRelated: async ({
        vendor,
        assetId,
    }: {
        vendor: string;
        assetId: number;
    }): Promise<AssetModel[]> => {
        const assets = await relatedService.getRelatedAssets({
            vendor,
            assetId,
        });
        return mapResponse(vendor, assets);
    },
};

export default recommendedList;
